import InfoRoundedIcon from "@mui/icons-material/InfoRounded"
import { Box, Stack, Typography, useTheme } from "@mui/material"
import { SxProps, Theme } from "@mui/material/styles"
import { deepmerge } from "@mui/utils"
import { ReactNode } from "react"

interface IEmptyDataProps {
  icon?: ReactNode
  primary?: string
  secondary?: string
  sx?: SxProps<Theme>
  className?: string
}

export const EmptyData = (props: IEmptyDataProps) => {
  const {
    icon = <InfoRoundedIcon />,
    primary = "",
    secondary = "",
    sx = {},
  } = props

  const theme = useTheme()
  const { styleOverrides } = theme.components?.[`EmptyData`] || {}
  const { root, primaryText, secondaryText, iconWrapper } = styleOverrides

  return (
    <Stack className="EmptyData-root" sx={deepmerge(root, sx)}>
      {icon && <Box sx={iconWrapper}>{icon}</Box>}
      {primary && (
        <Typography
          className="EmptyData-primary-text"
          sx={primaryText}
          component="div"
        >
          {primary}
        </Typography>
      )}
      {secondary && (
        <Typography
          className="EmptyData-secondary-text"
          variant="subtitle2"
          sx={secondaryText}
          component="div"
        >
          {secondary}
        </Typography>
      )}
    </Stack>
  )
}
